import { AxiosResponse } from 'axios';
import type { AxiosInstance } from 'axios';
import { inject } from '@aesop-fables/containr';
import { ApiServices } from '../ApiServices';
import { GroupMetricsData } from '../../models/MetricsData';

export class GroupMetricsApi {
  constructor(@inject(ApiServices.Axios) private axios: AxiosInstance) {}

  get(): Promise<AxiosResponse<GroupMetricsData>> {
    return this.axios.get('group-metrics');
  }

  getAll(): Promise<AxiosResponse<GroupMetricsData[]>> {
    return this.axios.get('group-metrics/all');
  }
}
